declare global {
    export interface Window {
        appInsights?: any
        NextFavourites?: any
        GoogleAnalyticsNext?: any
    }
}

export {getElementOffset} from "./getElementOffset"
export {getDocumentScrollTop} from "./getDocumentScrollTop"
export {getDocumentScrollLeft} from "./getDocumentScrollLeft"
export {getElementById} from "./getElementById"

export function IS_BROWSER(): boolean {
    return typeof window !== "undefined"
}

export function addDocumentScrollListener(listener: (this: Document, ev: Event) => any): void {
    return document.addEventListener("scroll", listener)
}

export function removeDocumentScrollListener(listener: (this: Document, ev: Event) => any): void {
    return document.removeEventListener("scroll", listener)
}

export function scrollToTop(): void {
    const window = getWindow()
    if (window) {
        window.scrollTo(0, 0)
    }
}

export function isSomewhatInViewport(element: Element): boolean {
    const position = element.getBoundingClientRect()
    if (
        (position.top < 0 && position.bottom > 0) ||
        (position.top >= 0 && position.bottom <= window.innerHeight) ||
        (position.top < window.innerHeight && position.bottom > window.innerHeight)
    ) {
        return true
    }
    return false
}

export function isAboveViewport(element: Element): boolean {
    const position = element.getBoundingClientRect()
    if (position.bottom <= 0) {
        return true
    }
    return false
}

export function isBelowViewport(element: Element): boolean {
    const position = element.getBoundingClientRect()
    if (position.top >= window.innerHeight) {
        return true
    }
    return false
}

export function getWindow(): Window | null {
    return IS_BROWSER() ? window : null
}
